export const createWixPayment = async (orderData) => {
  try {
    console.log('Creating Wix payment via backend:', orderData);
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/create-wix-payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orderData }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.success || !data.checkoutUrl) {
      throw new Error(data.error || 'Wix payment creation failed');
    }

    console.log('✅ Wix payment created successfully via backend:', data.checkoutUrl);
    return data;

  } catch (error) {
    console.error('❌ Error creating Wix payment via backend:', error);
    throw new Error(`Failed to create Wix payment: ${error.message}`);
  }
}; 